import { MetaRoles } from '@/core/constants/roleConstants';
// Role-based UI configuration for the Order Management view
const seller = {
  ui: {
    userFilter: false,
  },
  data: {
    scope: MetaRoles.Seller,
    filterField: 'salespersonId',
  },
};

const manager = {
  ui: {
    userFilter: false,
  },
  data: {
    scope: MetaRoles.Manager,
    filterField: 'salespersonId',
  },
};

const territorial = {
  ui: {
    userFilter: true,
    managerFilter: true,
  },
  data: {
    scope: MetaRoles.Regional,
    filterField: 'managerId',
  },
};

const subDirector = {
  ui: {
    userFilter: true,
  },
  data: {
    scope: MetaRoles.Subdirector,
    filterField: 'territoryId',
  },
};

const director = {
  ui: {
    userFilter: true,
  },
  data: {
    scope: MetaRoles.Director,
    filterField: 'sDirectorId',
  },
};

export default {
  [MetaRoles.Seller]: seller,
  [MetaRoles.Manager]: manager,
  [MetaRoles.RegionalManager]: territorial,
  [MetaRoles.Director]: director,
  [MetaRoles.Subdirector]: subDirector,
};
